<template>
  <div>
    <Header/>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container fluid>
      <b-row v-if="DiagnosticData.idPaciente != null && Number(DiagnosticData.idPaciente) > 0">
        <b-col>
          <pacientev2 :vistaCompleta="false" :propIdPaciente="Number(DiagnosticData.idPaciente)"></pacientev2>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <HojaCDXEComponente v-if="!cargaInCompleta"
              titulo="Validación PTI"
              :subtitulo="'PTI Presuntivo (Diagnóstico tratamiento)'"
              :codigo="'BJ_menu_ptiHallazgo'"
              @idPaciente="Number(DiagnosticData.idPaciente)"
              :idPtiCdx="idPti"
              :ptiCdxForzado="true"
              :detalle="true"
              :deshabilitar="DiagnosticData.intIdEstatusPTI == 3 ||
                banderaBtn == true ||
                DiagnosticData.intIdEstatusPTI == 4"
          />
        </b-col>
      </b-row>
    </b-container>

    <loading
        :active.sync="cargaInCompleta"
        :can-cancel="false"
        :is-full-page="true"
    ></loading>

  </div>
</template>

<script>
import {PtiPresuntivoService} from "@/apiServices/ptiPresuntivo/PtiPresuntivoService";
import Header from "../components/Header.vue";
import pacientev2 from "@/views/PacienteV2";
import HojaCDXEComponente from "@/components/hojasDiagnostico/HojaCDXEComponente";

export default {
  name: "Treatment",
  components: {
    Header,
    pacientev2,
    HojaCDXEComponente
  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    ptiPrsuntivoServicio: new PtiPresuntivoService(),
    banderaBtn: false,
    DiagnosticData: {
      idPaciente: 0,
      intIdEstatusPTI: null
    },
    cargaInCompleta: true,
    idPti: null

  }),
  methods: {
    getInfo() {
      //path: "/Centrodediagnostico/PTIPresuntivo/:id/:idSolicitudEtapa/:idSolicitud/:idEtapa",
      const parametros = {idSolicitudEtapa: this.$route.params.idSolicitudEtapa}
      this.$http
          .post(
              this.$api +
              "ptipresuntivo/obtener/datosGenerales", parametros
          )
          .then((response) => {
            let datos = response.data.data;
            this.DiagnosticData = {
              intIdEstatusPTI: datos.intIdEstatusPTI,
              idPaciente: datos.idPaciente,
            };
            this.cargaInCompleta = false;
          })
          .catch((error) => {
            this.$swal.fire({
              icon: "error",
              title: "Error",
              text: "El PTI no es valido",
            });
            console.error(error);
            this.cargaInCompleta = false;
          });
    },
  },
  beforeMount() {
    this.idPti = this.$route.params.id;
    this.getInfo();
  },
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
};
</script>
